import { render, staticRenderFns } from "./BankActivityDetail.vue?vue&type=template&id=0510c116"
import script from "./BankActivityDetail.vue?vue&type=script&lang=js"
export * from "./BankActivityDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports